import {React, useContext} from 'react';
import { Link } from 'react-router-dom';
import BreadcrumbsSection from './BreadcrumbsSection';
import gallery_example_1 from './static/img/gallery_example_1.jpg';
import gallery_example_2 from './static/img/gallery_example_2.jpg';
import gallery_example_3 from './static/img/gallery_example_3.jpg';
import gallery_example_4 from './static/img/gallery_example_4.png';
import gallery_example_5 from './static/img/gallery_example_5.jpg';
import RoutesContext from '../contexts/RoutesContext';

function GalleryPage(props) {
    let routes_context = useContext(RoutesContext)
  return (
    <main>
        <BreadcrumbsSection routes={routes_context.routes} page_name="Gallery" />

        <div className="gallery_content_section">
            <div className="gallery_content_inner_wrapper breadcrumbs_inner_wrapper">
                <div className="row_big">
                   <a data-fancybox="gallery" data-caption="<p>Türkmen çöli</p>" href={gallery_example_1}><img src={gallery_example_1} alt="" /></a>
                   <a data-fancybox="gallery" data-caption="<p>Türkmen ýaz</p>" href={gallery_example_2}><img src={gallery_example_2} alt="" /></a>
                </div>

                <div className="row_small">
                   <a data-fancybox = "gallery" data-caption="<p>Türkmen sazak</p>" href={gallery_example_3}><img src={gallery_example_3} alt="" /></a>
                   <a data-fancybox = "gallery" data-caption="<p>Köw ata</p>" href={gallery_example_4}><img src={gallery_example_4} alt="" /></a>
                   <a data-fancybox = "gallery" data-caption="<p>Türkmen jülgesi</p>" href={gallery_example_5}><img src={gallery_example_5} alt="" /></a>
                </div>

                <div className="row_big">
                    <a data-fancybox="gallery" data-caption="<p>Türkmen çöli</p>" href={gallery_example_1}><img src={gallery_example_1} alt="" /></a>
                    <a data-fancybox="gallery" data-caption="<p>Türkmen ýaz</p>" href={gallery_example_2}><img src={gallery_example_2} alt="" /></a>
                 </div>
 
                 <div className="row_small">
                    <a data-fancybox = "gallery" data-caption="<p>Türkmen sazak</p>" href={gallery_example_3}><img src={gallery_example_3} alt="" /></a>
                    <a data-fancybox = "gallery" data-caption="<p>Köw ata</p>" href={gallery_example_4}><img src={gallery_example_4} alt="" /></a>
                    <a data-fancybox = "gallery" data-caption="<p>Türkmen jülgesi</p>" href={gallery_example_5}><img src={gallery_example_5} alt="" /></a>
                 </div>
                <div className="gallery_more_button_container">
                    <Link to={routes_context.routes.gallery_all.path} className="btn_animation green">Doly görkezmek</Link>
                </div>
            </div>
        </div>


    </main>
  );
}

export default GalleryPage;